/**
 *
 * "Generates a kit table for .DocX export"
 *
 * @file   data.js
 * @author Lateral
 * @since  2023
 */
import { groupBy } from 'common/arrays'
import { otherName, panelName, sideLinerName } from './panelNames'

function isDarkColor(hex) {
  hex = hex.replace('#', '')
  if (hex.length === 3) {
    hex = hex
      .split('')
      .map((c) => c + c)
      .join('')
  }
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)

  const brightness = (r * 299 + g * 587 + b * 114) / 1000
  return brightness < 128 // Returns true if dark, false if light
}
export function getBillOfMaterial(deckRevision, $newFormat = false) {
  /**
   * Create a B.O.M. table to export to .DocX document
   *
   * @function
   *
   * @param {object} deckRevision - Deck revision object
   * @param {object[]} deckRevision.kits - Array of kit material objects
   * @param {object[]} deckRevision.Panels - Array of deck panel objects
   * @param {object[]} deckRevision.SideLiners - Array of deck sideliner objects
   *
   * @returns {object} - A B.O.M. table with kit list
   */

  let kitList = []
  const panels_ = []
  const sideLiners_ = []
  const others_ = []
  for (const kit of deckRevision.Kits) {
    const panels = deckRevision.Panels.filter((p) => p.MaterialNumber === kit.MaterialNumber)
    const sideLiners = deckRevision.SideLiners.filter((s) => s.MaterialNumber === kit.MaterialNumber)
    const fontColor =
      kit.Colour && kit.Colour.includes('#') ? (isDarkColor(kit.Colour) ? '#FFFFFF' : '#000000') : '#000000'

    if (panels.length) {
      panels_.push({
        Location: panelName,
        QTY: panels.length,
        Material: kit.MaterialDescription ? kit.MaterialNumber : kit.PartNumber,
        Description: kit.MaterialDescription ? kit.MaterialDescription : kit.MaterialNumber,
        Code: kit.CustomerStockCode,
        colorCode: kit.Colour,
        fontcolor: fontColor
      })
    } else if (sideLiners.length) {
      sideLiners_.push({
        Location: sideLinerName,
        QTY: sideLiners.length,
        Material: kit.MaterialDescription ? kit.MaterialNumber : kit.PartNumber,
        Description: kit.MaterialDescription ? kit.MaterialDescription : kit.MaterialNumber,
        colorCode: kit.Colour,
        fontcolor: fontColor
      })
    } else {
      others_.push({
        Location: otherName,
        QTY: kit.Quantity,
        Material: kit.MaterialDescription ? kit.MaterialNumber : '',
        Description: kit.MaterialDescription ? kit.MaterialDescription : kit.MaterialNumber,
        Code: kit.CustomerStockCode,
        Colour: kit.Colour
      })
    }
  }

  kitList = [...panels_, ...sideLiners_, ...others_]

  for (let i = 0; i < kitList.length; i++) {
    kitList[i].Item = i + 1
  }

  if ($newFormat) {
    return groupBy('Location')(kitList)
  }

  return kitList
}
